// Set by logout just before it opens the sign-in page, so that page can say the
// user was logged out. Kept in memory on purpose, so a reload shows the plain
// page again; Layout clears it when the user goes to any other page.
let justLoggedOut = false

export const markLoggedOut = () => {
  justLoggedOut = true
}

export const wasJustLoggedOut = () => justLoggedOut

export const clearLoggedOut = () => {
  justLoggedOut = false
}
